import React from 'react';
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { DatePicker } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';

import * as actions from '../../../../store/actions/indexes';
const Datepicker = props => {

    const dispatch = useDispatch();

    const isControlledFiltersOpen = useSelector((state) => state.controlledComponentsReducer.isControlledFiltersOpen, shallowEqual);
    const onOpenClosePicker = (e) => {
        if (e) {
            let copyOfFilterStates = JSON.parse(JSON.stringify(isControlledFiltersOpen));
            for (const key in copyOfFilterStates) {
                copyOfFilterStates[key] = false
            }
            dispatch(actions.setControlledFiltersOpen(copyOfFilterStates))
        }
    }
    return (
        <DatePicker
            key={props.key}
            suffixIcon={<CaretDownOutlined className="ant-picker-suffix" />}
            // onChange={onChange} 
            // disabledDate={ d => !d || ( this.state.maxDate != null && d.isAfter(this.state.maxDate)) }
            style={{ width: '100%' }}
            picker={props.pickerType}
            placeholder={props.placeholder}
            format={props.format}
            showToday={false}
            onOpenChange={onOpenClosePicker}
        />
    );
}

export default React.memo(Datepicker);